module.exports = __webpack_public_path__ + "img/ytzb.220d80a6.png";